import { render, staticRenderFns } from "./DisabledActivity.vue?vue&type=template&id=2fa5dd06&scoped=true&"
import script from "./DisabledActivity.vue?vue&type=script&lang=js&"
export * from "./DisabledActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa5dd06",
  null
  
)

export default component.exports